import { TypedUseSelectorHook, useSelector } from 'react-redux'
import { combineReducers } from 'redux'
import { persistReducer } from 'redux-persist'
import hardSet from 'redux-persist/lib/stateReconciler/hardSet'
import storage from 'redux-persist/lib/storage'

import {
  activePurchasersCountReducer, invoiceCountReducer, transactionStatsReducer
} from './dashboard'
import featureToggleReducer from './featureToggle'
import invoiceReducer, {
  invoicePDFReducer,
  invoiceSpecificationExcelReducer
} from './invoice'
import invoiceRecipientAdminsReducer from './invoiceRecipientAdmins'
import invoiceRecipientsReducer from './invoiceRecipients'
import invoicesReducer from './invoices'
import loginReducer from './login'
import orgAccountReducer from './orgAccount'
import orgAccountAdminReducer from './orgAccountAdmin'
import organizationAdminReducer from './organizationAdmin'
import purchaserReducer from './purchaser'
import purchasersReducer from './purchasers'
import transactionReducer from './transaction'
import transactionsReducer from './transactions'

import lastLocationReducer from 'redux/ducks/lastLocation'
import modalReducer from 'redux/ducks/modal'
import toastReducer from 'redux/ducks/toast'
import tooltipReducer from 'redux/ducks/tooltip'

const persistLoginConfig = {
  key: 'login',
  storage,
  whitelist: ['data'],
  stateReconciler: hardSet,
}

const rootReducer = combineReducers({
  modal: modalReducer,
  toast: toastReducer,
  tooltip: tooltipReducer,
  lastLocation: lastLocationReducer,
  login: persistReducer(persistLoginConfig, loginReducer),
  dashboard: combineReducers({
    paymentPurchasers: activePurchasersCountReducer,
    invoiceCount: invoiceCountReducer,
    transactionStats: transactionStatsReducer,
  }),
  organizationAdmin: organizationAdminReducer,
  orgAccount: orgAccountReducer,
  orgAccountAdmin: orgAccountAdminReducer,
  invoiceRecipients: invoiceRecipientsReducer,
  invoiceRecipientAdmins: invoiceRecipientAdminsReducer,
  purchasers: purchasersReducer,
  purchaser: purchaserReducer,
  invoices: invoicesReducer,
  invoice: invoiceReducer,
  invoicePDF: invoicePDFReducer,
  invoiceSpecificationExcel: invoiceSpecificationExcelReducer,
  transactions: transactionsReducer,
  transaction: transactionReducer,
  featureToggle: featureToggleReducer,
  organization: orgAccountReducer,
})

export type State = ReturnType<typeof rootReducer>
export default rootReducer




export const useAppSelector: TypedUseSelectorHook<State> = useSelector